import { NoHoldingsWrapper } from './styled';

export const NoHoldings = () => {
  return (
    <NoHoldingsWrapper>
      <p>Start building a portfolio. Search for companies to add.</p>
    </NoHoldingsWrapper>
  );
};
